import { useTranslation, Trans } from 'react-i18next';
import CurrencyText from '~src/domains/common/components/CurrencyText';
import { Locale } from '~src/domains/common/enums/localization';
import { LoanOfferType } from '~src/domains/common/types/offers';

import * as styles from '~src/styles/domains/start/StartPage.module.scss';
import SubventionPromo from './SubventionPromo';

interface StartFromPricingProps {
  offer: LoanOfferType;
  locale: Locale;
}

export default function StartFromPricing({
  offer,
  locale,
}: StartFromPricingProps) {
  const { t } = useTranslation();

  if (!offer) return <></>;

  return (
    <div className={styles['start-info-pricing']}>
      <div className={styles['start-info-pricing-estimated-wrapper']}>
        {t('start:estimated-payment.header')}
        <span className={styles['start-info-pricing-estimated-from']}>
          <Trans
            t={t}
            i18nKey='start:estimated-payment.from-payment'
            components={{
              payment: (
                <CurrencyText
                  value={offer.monthly_payment_amount}
                  locale={locale}
                  id={styles['start-info-estimated-currency']}
                  className={'start-info-estimated-amount'}
                />
              ),
            }}
          />
        </span>
      </div>
      <div className={styles['start-info-legal-notice']}>
        <Trans
          t={t}
          i18nKey='start:estimated-payment.apr'
          components={{
            apr: (
              <CurrencyText
                value={offer.apr}
                locale={locale}
                isApr={true}
                id={'start-estimate-apr'}
              />
            ),
            downpayment: (
              <CurrencyText
                value={offer.down_payment}
                locale={locale}
                id={'start-estimate-down-payment'}
              />
            ),
            numberofpayments: <span id='start-estimate-number-of-payments' />,
          }}
          values={{ numberOfPayments: offer.number_of_payments }}
        />
      </div>
      <SubventionPromo />
    </div>
  );
}
